import { render, staticRenderFns } from "./RimGoodsComponent.vue?vue&type=template&id=c133af3c&scoped=true&"
import script from "./RimGoodsComponent.vue?vue&type=script&lang=js&"
export * from "./RimGoodsComponent.vue?vue&type=script&lang=js&"
import style0 from "./RimGoodsComponent.vue?vue&type=style&index=0&id=c133af3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c133af3c",
  null
  
)

export default component.exports